<template>
  <div class="position-relative" style="overflow-x: hidden;">
    <div class="chart">
      <canvas :id="this.v_id" class="chart-canvas" :height="this.cvheight"></canvas>
    </div>
</div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "gradient-line-chart",
  props: {
    cvheight: {
      type: Number,
      required: false,
      default: 165,
    },
    v_id: {
      type: String,
      required: true,
    },
    realized: {
      type: Number,
      default: 0
    },
    target: {
      type: Number,
      default: 1,
    },
    bgcolor: {
      type: String,
      default: "#52cb58",
    },
    fgcolor: {
      type: String,
      default: "#e3f9e6",
    },
    title: {
      type: String,
      default: "Sales overview",
    },
    detail1: {
      type: String,
      default: "4% more",
    },
    detail2: {
      type: String,
      default: "in 2021",
    },
  },

  mounted() {
    const ctx1 = document.getElementById(this.v_id).getContext("2d");

    const gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

    gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
    gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
    gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");
    const drawNeedle = (radius, radianAngle) => {
        const canvas = document.getElementById(this.v_id);
        const ctx = canvas.getContext('2d');
        const cw = canvas.offsetWidth;
        const ch = canvas.offsetHeight;
        const cx = cw / 2;
        const cy = ch - 8;

        ctx.translate(cx, cy);
        ctx.rotate(radianAngle);
        ctx.beginPath();
        ctx.moveTo(0, -5);
        ctx.lineTo(radius, 0);
        ctx.lineTo(0, 5);
        ctx.fillStyle = 'rgba(0, 0, 0, 1)';
        ctx.fill();
        ctx.rotate(-radianAngle);
        ctx.translate(-cx, -cy);
        ctx.beginPath();
        ctx.arc(cx, cy, 7, 0, Math.PI * 2);
        ctx.fill();
    }

    const chart = new Chart(ctx1, {
      type: "doughnut",
      data: {
        labels: ["Terealisasi", "Belum Terealisasi"],
        datasets: [
          {
            needleValue: 27,
            label: "Mobile apps",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            backgroundColor: [this.bgcolor, this.fgcolor],
            // eslint-disable-next-line no-dupe-keys
            fill: true,
            data: [this.realized, 100-this.realized],
            maxBarThickness: 6,
          },
        ],
      },
      options: {
        coba: 123,
        animation: {
          onProgress: () => {
            drawNeedle(165, ((90 + ((Number.parseInt(this.realized, 10)/100 * 180)/2)) * 2 * Math.PI / 180))
            drawNeedle(165, ((90 + ((Number.parseInt(this.realized, 10)/100 * 180)/2)) * 2 * Math.PI / 180))
          },
          onComplete: () => {
            drawNeedle(165, ((90 + ((Number.parseInt(this.realized, 10)/100 * 180)/2)) * 2 * Math.PI / 180))
          }
        },
        rotation: -90,
        circumference: 180,
        cutoutPercentage: 30,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
        scales: {
          y: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: true,
              drawTicks: false,
              borderDash: [5, 5],
            },
            ticks: {
              display: false,
              padding: 10,
              color: "#fbfbfb",
              font: {
                size: 11,
                family: "Open Sans",
                style: "normal",
                lineHeight: 2,
              },
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false,
              drawOnChartArea: false,
              drawTicks: false,
              borderDash: [5, 5],
            },
            ticks: {
              display: false,
              color: "#ccc",
              padding: 20,
              font: {
                size: 11,
                family: "Open Sans",
                style: "normal",
                lineHeight: 2,
              },
            },
          },
        },
      },
    });
    return chart;
  },
};
</script>
